import * as React from 'react';

import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';

import EComValidationInput, { EComValidationProps } from 'root/apps/eComValidation';
import { getMountProps } from 'root/apps/eComValidation/utils';
import { TaxClassServiceTypeToggle } from 'root/apps/TaxClassForm/TaxClassServiceTypeToggle';
import { ClassType } from 'root/apps/TaxClassForm/types';
import Modules from 'shared_modules/Modules';

const TaxClassFormRow = styled(Box)`
  margin-bottom: 15px;
  .label {
    font-weight: bold;
    width: 170px;
  }
`;

export interface TaxClassFormProps {
  eComValidationProps: EComValidationProps;
  type: ClassType;
  domQueryTypeInput: string;
  isLastLaborClass: boolean;
}

export const TaxClassForm: React.FC<TaxClassFormProps> = ({
  eComValidationProps,
  type,
  domQueryTypeInput,
  isLastLaborClass,
}) => {
  const [typeInputElement] = React.useState(
    document.querySelector<HTMLInputElement>(domQueryTypeInput)
  );

  const hasWorkbenchModule = Modules.hasModule('workbench');

  const eComValidationInputProps = {
    ...getMountProps({ name: 'admin.views.class' }, [eComValidationProps]),
    ...eComValidationProps,
  };
  return (
    <Box>
      <TaxClassFormRow>
        <EComValidationInput {...eComValidationInputProps} />
      </TaxClassFormRow>
      {hasWorkbenchModule && typeInputElement && (
        <TaxClassFormRow>
          <TaxClassServiceTypeToggle
            type={type}
            typeInputElement={typeInputElement}
            isLastLaborClass={isLastLaborClass}
          />
        </TaxClassFormRow>
      )}
    </Box>
  );
};
